interface Feature {
  id: number;
  icon: string;
  title: string;
  description: string;
}

interface FeaturesSectionProps {
  features: Feature[];
}

export default function FeaturesSection({ features }: FeaturesSectionProps) {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-6xl">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14 gap-4">
          <div>
            <p className="text-primary-600 text-sm font-semibold tracking-wide mb-2">核心优势</p>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
              为什么选择<span className="text-accent-500"> NOPAY</span>？
            </h2>
          </div>
          <span className="inline-block px-4 py-1.5 bg-foreground-900 text-white text-xs font-medium rounded-full whitespace-nowrap">
            金融级安全保障
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-lg p-6 md:p-7 group hover:bg-background-50 transition-colors"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}